(function ($) {
  // On Dom Ready
  $(function () {
    // Ajax add to cart on the product page
    var $warp_fragment_refresh = {
      url: wc_cart_fragments_params.wc_ajax_url.toString().replace("%%endpoint%%", "get_refreshed_fragments"),
      type: "POST",
      success: function (data) {
        if (data && data.fragments) {
          $.each(data.fragments, function (key, value) {
            $(key).replaceWith(value);
          });

          $(document.body).trigger("wc_fragments_refreshed");
        }
      },
    };

    $(".entry-summary form.cart").on("submit", function (e) {
      e.preventDefault();

      var button_text = $(".entry-summary").find("form.cart .button").html();
      $(".entry-summary").block({
        message: null,
        overlayCSS: {
          cursor: "none",
        },
      });

      var product_url = window.location,
        form = $(this);

      $.post(product_url, form.serialize() + "&_wp_http_referer=" + product_url, function (result) {
        var cart_dropdown = $(".widget_shopping_cart", result);

        // update dropdown cart
        $(".widget_shopping_cart").replaceWith(cart_dropdown);

        // update fragments
        $.ajax($warp_fragment_refresh);

        // show error if exists
        if ($(result).find(".woocommerce-notices-wrapper ul.woocommerce-error").length > 0) {
          $(".notice-wrapper").html($(result).find(".woocommerce-notices-wrapper"));
          $(".entry-summary").find("form.cart .button").html(button_text);
        } else {
          $(".notice-wrapper").html("");
          $(".entry-summary").find("form.cart .button").html("Added");
        }
        $(".entry-summary").unblock();
      });
    });

    // Change add to cart button text after added to cart from loop
    $(document.body).on("adding_to_cart", function ($button, data) {
      var the_button = $(data[0]);
      the_button.attr("disabled", "true");
      the_button.blur();
    });

    $(document.body).on("added_to_cart", function (event, fragments, cart_hash, $button) {
      let button_text = $($button[0]).html();
      var the_button = $($button[0]);
      the_button.html("Added");
      setTimeout(() => {
        the_button.html(button_text);
        the_button.removeClass("added");
        the_button.removeAttr("disabled");
      }, 3000);
    });

    // Move Coupon Form
    $(".checkout_coupon").show();
    var coupon = $(".checkout_coupon");
    $(coupon).insertAfter(".shop_table.woocommerce-checkout-review-order-table");
  });
})(jQuery);
